import { Component, EventEmitter, Input, OnInit, Output, ViewEncapsulation } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ModalTemplate } from '../../../models/common-model';
import { Dialog } from 'primeng/dialog';

@Component({
  selector: 'careposi-modal-template',
  standalone: true,
  imports: [
    CommonModule,
    Dialog
  ],
  templateUrl: './modal-template.component.html',
  styleUrls: ['./modal-template.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class ModalTemplateComponent implements OnInit {
  @Input() modalTemplate: ModalTemplate = new ModalTemplate();
  @Output() closeModalHandler = new EventEmitter();
  isDisplay: boolean = false;
  constructor() { }

  ngOnInit(): void {
    this.isDisplay = true;
  }
  closeModal(){
    this.isDisplay = false;
    this.closeModalHandler.emit();
  }

  /** X / Esc: hides the modal, or with confirmClose keeps it shown and only tells the owner */
  onVisibleChange(visible: boolean) {
    if (!visible && this.modalTemplate.confirmClose) {
      this.closeModalHandler.emit();
      return;
    }
    this.isDisplay = visible;
  }

}
